import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {
  Area,
  Challenge,
  CreateIdeaChallenge,
  CreateIdeaCountryInput,
  CreateIdeaGQL,
  CreateIdeaInput,
  GetAreasGQL,
  GetAreasQuery,
  GetChallengesByLanguageGQL,
  GetChallengesByLanguageQuery,
  GetChallengesGQL,
  IdeaExpectation,
} from '../../../generated/graphql';
import {Apollo, QueryRef} from 'apollo-angular';
import {BaseComponent} from '../../base/base.component';
import {ActivatedRoute, Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {EventBusService} from '../../service/event-bus.service';
import { GetChallengeByIdGQL, GetChallengeByIdQuery } from 'src/generated/graphql/challenge/get-challenge-by-id.graphql';
import { CreateIdeaReduceGQL } from 'src/generated/graphql/idea/create-idea-reduce.graphql';
import { IdeaAttachmentService } from '../../service/idea-attachment.service';
import {CountryCard, CountryUnity, CountryUnityService} from '../../service/country-unity.service';

declare var $: any;

@Component({
  selector: 'app-register-challenge-idea',
  templateUrl: './register-challenge-idea.component.html',
  styleUrls: ['./register-challenge-idea.component.scss']
})
export class RegisterChallengeIdeaComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  // anexos selecionados no cadastro; enviados depois que a ideia é criada
  attachments: File[] = [];


  subscription: Subscription;
  page = 'description';

  model: CreateIdeaInput = new CreateIdeaInput();
  modelAuthorDetail: any = {};

  modelEmailConfirm = null;

  challenges: Challenge[] = [];
  challengesQuery: QueryRef<GetChallengesByLanguageQuery>;

  challengeByIdQuery: QueryRef<GetChallengeByIdQuery>;

  countries: Observable<CountryCard[]>;
  countriesUnity: Observable<CountryUnity[]>;
  selectedCountry: CountryCard;

  areas: Array<Area> = [];
  areasQuery: QueryRef<GetAreasQuery>;

  modelExpectations: any = [
    {isSelect: false, expectation: 'finance', expectationDescription: ''},
    {isSelect: false, expectation: 'productive', expectationDescription: ''},
    {isSelect: false, expectation: 'sustainability', expectationDescription: ''}
  ];

  recordStream = false;
  challengeId: string;

  constructor(public router: Router,
              public router2: ActivatedRoute,
              public translate: TranslateService,
              private eventbus: EventBusService,
              private apollo: Apollo,
              private getChallengesGQL: GetChallengesGQL,
              private getAreasGQL: GetAreasGQL,
              private getChallengesByLanguageGQL: GetChallengesByLanguageGQL,
              private getChallengeByIdGQL: GetChallengeByIdGQL,
              private createIdeaGQL: CreateIdeaGQL,
              private createIdeaReduceGQL: CreateIdeaReduceGQL,
              private ideaAttachmentService: IdeaAttachmentService,
              private countryUnityService: CountryUnityService) {
    super(router, translate);
    this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      $(() => {
        this.challengesQuery.refetch({language: localStorage.getItem('culture')});
      });
    });
  }

  ngOnDestroy(): void {
    $('.header').removeClass('d-none');
    $('.footer').removeClass('d-none');
    const newAuthor = $('#newAuthor');
    if (newAuthor[0]) {
      newAuthor.remove();
    }
  }

  ngOnInit(): void {
    $('.header').addClass('d-none');
    $('.footer').addClass('d-none');

    this.getParamsOfRouter()
    this.verifyRouter()
    this.getCountries()
    this.getAreas();
    this.getChallengeById()

    this.model.authors = [];
  }

  ngAfterViewInit() {
  }

  verifyRouter() {
    this.recordStream = this.handlerRegister();
  }

  getParamsOfRouter() {
    this.router2.params.subscribe(url => {
      if (!this.isNullOrUndefined(url)) {
          this.challengeId = url.challengeId;
      }
  });
  }

  getCountries() {
    this.countries = this.countryUnityService.getCountryCards();
  }

  getChallengeById() {
    const data = {
      id: this.challengeId,
      language: localStorage.getItem('culture'),
    }

    this.challengeByIdQuery = this.getChallengeByIdGQL.watch(data);

    this.challengeByIdQuery.valueChanges.subscribe({
      next: (response) => {
      this.model.challenge = new CreateIdeaChallenge();
      this.model.challenge = response.data.getChallenge;
    },
      error: (error) => {},
    });
  }

  handlerRegister() {
    return this.router.url === '/register';
  }

  onBackModal(page: string) {
    this.page = page;
  }

  onNextModal(page: string) {
    this.page = page;
    if (page === 'finish') {
      setTimeout(() => {
        $('.idea-finish_col-primary').css('max-width', '100%');
        $('.idea-finish_col-secondary').css('border-radius', '10px 0 0 10px');
      }, 250);
      setTimeout(() => {
        $('.idea-finish_col-secondary_padding').css('opacity', '1');
      }, 500);
    }
    if (page === 'challenge') {
      $('#idea').modal('hide');
      this.router.navigate(['/']);
    }
  }

  onNavigate(router: string) {
    this.router.navigate([router]);
  }

  // STEP 2
  validateDescriptionFields(): boolean {
    const arrValidateFields = [
      {value: this.model.authorName, text: this.translate.instant('ideaMaker.ideaTitle') + ', <br />'},
      {value: this.model.currentProblem, text: this.translate.instant('ideaMaker.currentProblem') + ', <br />'},
      {value: this.model.problemSolution, text: this.translate.instant('ideaMaker.possibleSolutions') + ', <br />'},
      {value: this.model.authorName, text: this.translate.instant('author.name') + ', <br />'},
      {value: this.model.re, text: 'RE, <br />'},
      // {value: this.model.phone, text: this.translate.instant('author.phone') + ' <br />'},
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + `<br><br> ${stringError}`);
      return false
    }

    return true;
  }

  onStepSaveSecond() {
    const validFields = this.validateDescriptionFields();

    validFields && this.onNextModal('unity');
  }

  // STEP 3
  onGetUnityByCountry(card: CountryCard) {
    this.selectedCountry = card;
    this.countriesUnity = this.countryUnityService.getUnities(card);
    this.model.unity = null;
    this.model.country = null;
  }

  // A ideia grava o país real da unidade, inclusive em "Unidades Internacionais".
  onChangeUnity(unity: CountryUnity) {
    const countryIf: CreateIdeaCountryInput = {id: unity.countryId};
    this.model.country = countryIf;
    this.model.unity = {id: unity.id};
  }

  onStepSaveThree() {
    if (this.isNullOrUndefined(this.model.unity) || this.isNullOrUndefined(this.model.country)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('selectcountry'));
      return;
    }
    
    this.onNextModal('contact');
  }

  // STEP 4
  onStepSaveFour() {
    const arrValidateFields = [
      {value: this.model.email, text: 'E-mail, <br />'},
      {value: this.modelEmailConfirm, text: 'Repita o e-mail, <br />'}
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + `<br><br> ${stringError}`);
      return;
    }
    if (!this.isEMailValid(this.model.email)) {
      return;
    }
    if (this.model.email !== this.modelEmailConfirm) {
      super.showMessage(this.translate.instant('attention'), this.translate.instant('verify'));
      return;
    }

    delete this.model.challenge['__typename']
    
    $('#loaderBox').fadeIn();
    this.createIdeaReduceGQL.mutate({data: this.model}).subscribe(
      async ({data}) => {
        // anexos só com sessão (o upload exige token); falha de um não impede os demais
        const results = this.hasSession && this.attachments.length && data?.createIdeaReduce?.id
          ? await this.ideaAttachmentService.uploadAll('idea', data.createIdeaReduce.id, this.attachments)
          : [];
        this.attachments = [];
        this.model = new CreateIdeaInput();
        this.modelAuthorDetail = {};
        this.modelEmailConfirm = null;

        this.onNextModal('finish');
        $('#loaderBox').fadeOut();
        const summary = this.ideaAttachmentService.summarize(results);
        if (summary) {
          this.showMessage(this.translate.instant('attachments.summaryTitle'), summary.html, summary.type);
        }
      }, (err) => {
      }
    );
  }

  /** O cadastro público (sem login) não mostra anexos: o upload exige token. */
  get hasSession(): boolean {
    return !!sessionStorage.getItem('token');
  }

  openModalAuthor(id: string) {
    if ((this.model.authors.length > 1)) {
      this.showMessage(this.translate.instant('attention'), 'Conforme política do Programa Clic, a ideia pode ter no máximo 3 autores');
      $('#' + id).modal('hide');
      return;
    } else {
      $('#' + id).modal('show');
    }
  }

  onAddAuthor() {
    if (!this.model.authors) {
      this.model.authors = [];
    }

    const authors = this.model.authors?.filter((x) => x === this.modelAuthorDetail.name);
    if (authors.length === 0) {
      this.model.authors.push({
        name: this.modelAuthorDetail.name,
        re: this.modelAuthorDetail.re,
      });
      this.modelAuthorDetail = {};
    }
  }

  onRemoveAuthor(i: number) {
    this.confirmMessage(this.translate.instant('attention'), 'Deseja realmente remover o author?', () => {
      this.model.authors.splice(i, 1);
    });
  }

  private getAreas() {
    this.areasQuery = this.getAreasGQL.watch();
    this.areasQuery.valueChanges.subscribe(({data}) => {
      this.areas = data.areas as Array<Area>;
    });
  }

}
